export default __webpack_public_path__ + "static/media/default_marker.f5af240d.svg";